/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL21haW4vcG1zL2N1c3RvbWVyL3N0cmlwZS10cmFuc2FjdGlvbnMvc3RyaXBlLXRyYW5zYWN0aW9ucy5jb21wb25lbnQuc2NzcyJ9 */"];
export { styles as styles };
